var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4983 7.27468C16.4433 7.26551 16.3791 7.26551 16.3241 7.27468C15.0591 7.22885 14.0508 6.19301 14.0508 4.90968C14.0508 3.59885 15.1049 2.54468 16.4158 2.54468C17.7266 2.54468 18.7808 3.60801 18.7808 4.90968C18.7716 6.19301 17.7633 7.22885 16.4983 7.27468Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5548 13.948C16.8107 14.1589 18.1948 13.9389 19.1665 13.288C20.459 12.4264 20.459 11.0147 19.1665 10.153C18.1857 9.5022 16.7832 9.2822 15.5273 9.5022",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47391 7.27468C5.52891 7.26551 5.59307 7.26551 5.64807 7.27468C6.91307 7.22885 7.92141 6.19301 7.92141 4.90968C7.92141 3.59885 6.86724 2.54468 5.55641 2.54468C4.24557 2.54468 3.19141 3.60801 3.19141 4.90968C3.20057 6.19301 4.20891 7.22885 5.47391 7.27468Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41698 13.948C5.16114 14.1589 3.77698 13.9389 2.80531 13.288C1.51281 12.4264 1.51281 11.0147 2.80531 10.153C3.78615 9.5022 5.18864 9.2822 6.44448 9.5022",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9983 14.1222C10.9433 14.113 10.8791 14.113 10.8241 14.1222C9.55911 14.0764 8.55078 13.0405 8.55078 11.7572C8.55078 10.4464 9.60495 9.39221 10.9158 9.39221C12.2266 9.39221 13.2808 10.4555 13.2808 11.7572C13.2716 13.0405 12.2633 14.0855 10.9983 14.1222Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33266 17.0097C7.04016 17.8714 7.04016 19.283 8.33266 20.1447C9.79932 21.1255 12.201 21.1255 13.6677 20.1447C14.9602 19.283 14.9602 17.8714 13.6677 17.0097C12.2102 16.038 9.79932 16.038 8.33266 17.0097Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.1acb9b8ab65161b24e849b4eb014c8f4.svg";
export { ForwardRef as ReactComponent };